
import Vue from "vue";
import { FormsAndSurveyServices } from "@/services";
import config from "@/config";
import { emitter, NotificationType } from "@/composables/emitter";
export default Vue.extend({
  data() {
    return {
      surveys: [] as { _id: string, name: string}[],
      surveyId: "",
      thumbnailFile: undefined as any,
      themeName: "",
      category: "",
      priority: 1,
    };
  },
  computed: {
    validAddPrebuiltSurvey(): boolean {
      return this.themeName && this.surveyId && this.thumbnailFile && this.category ? true : false;
    },
  },
  methods: {
    async getAllSurveys() {
      try {
        const allSurveys = await FormsAndSurveyServices.getAllSurveysForThemes({
          locationId: config.prebuiltSurveyLocation,
          limit: 50
        });
        this.surveys = allSurveys.data.surveys;
      } catch (error) {
        console.error(error);
      }
    },
    async addPrebuiltSurvey() {
      try {
        const bodyThemeData = new FormData();
        bodyThemeData.append("themeName", this.themeName);
        bodyThemeData.append("thumbnail", this.thumbnailFile);
        bodyThemeData.append("surveyId", this.surveyId);
        bodyThemeData.append("category", this.category);
        bodyThemeData.append("priority", this.priority.toString());
        const result = await FormsAndSurveyServices.createSurveys(bodyThemeData);
        if (result.status === 201) {
          this.resetInput()
        }
      } catch (error: any) {
        console.error(error);
        const data = this.$refs.thumbnailUpload as HTMLInputElement;
        data.value  = '';
        emitter.$emit("notification", {
          title: "Add Failed",
          message: error.response?.data?.message || error,
          type: NotificationType.ERROR,
        });
      }
    },
    readThumbnailChange(e: any) {
      const element = <HTMLInputElement>e.target;
      if (!element.files) return;
      this.thumbnailFile = element.files[0];
    },
    resetInput(){
      this.themeName = "";
      this.surveyId = "";
      this.thumbnailFile = undefined;
      this.category = "";
      this.priority = 1;
      const data = this.$refs.thumbnailUpload as HTMLInputElement;
      data.value  = '';
    }
  },
  async mounted() {
    await this.getAllSurveys();
  },
});
